import PurseSearch from '../../src/legacy/PurseSearch';
export default PurseSearch;
